import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import SadIcon from '@mui/icons-material/SentimentVeryDissatisfied';

// Styles.
import {ErrorLogStyles as styles} from "./ErrorLog.styles";

/**
 * Returns a block with error data.
 * @param { object } errorInfo: Information about the log error.
 * @param { string } dataKey: The key to received to be validated.
 * @param { string } dataType: The data type expected.
 * @param { string } component: The name of the component related with the error.
 * @param { string } environment: Environment of the current user.
 * @returns {JSX.Element}
 */
function ErrorLog({errorInfo, dataKey = null, dataType = null, component = "the", environment}) {
  // If user is not on dev mode display friendly error.
  if(environment !== 'development') return  (
    <Box className='ErrorLog__error friendly-error' sx={styles}>
      <SadIcon sx={{ fontSize: 120 }} color="primary"/>
      <h3 className='error__title'>Sorry we had a problem loading {component} data </h3>
      <p className='error__message'>No one is perfect, we are working hard to solve the error.</p>
    </Box>
  );

  // Send a log to error.
  if(environment === 'development') {
    errorInfo.component = component
    console.log(errorInfo)
  }

  // If user in on dev mode displays useful data.
  switch (errorInfo.type) {
    case 'Fetch Error':
      return (
        <Box className='ErrorLog__error' sx={styles}>
          <h3 className='error__title'>{ errorInfo.response ? 'HTTP Request Error:' : 'Network Error:' }</h3>
          {
            errorInfo.response
              ? <p className='error__message'>{errorInfo.response.status} {errorInfo.response.statusText}</p>
              : <p> No Response Received at: </p>
          }
          <p className='error__url'>{errorInfo?.config?.url}</p>
        </Box>
      )
    case 'Data Error':
      return (
        <Box className='ErrorLog___error' sx={styles}>
          <h3 className='error__title'>Data type Error</h3>
          <p>{errorInfo.message}</p>
        </Box>
      )
    default :
      return (
        <Box className='ErrorLog___error' sx={styles}>
          <h3>{errorInfo.name}</h3>
          <p>{errorInfo.message}</p>
        </Box>
      )
  }
}

ErrorLog.propTypes = {
  errorInfo: PropTypes.object.isRequired,
  dataKey: PropTypes.string,
  dataType: PropTypes.string,
  component: PropTypes.string,
  environment: PropTypes.string,
}
export default React.memo(ErrorLog);
